import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Location } from '@vendasta/atlas';
import { LocationListItemComponent } from './location-list-item/location-list-item.component';

@Component({
  selector: 'atlas-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.scss'],
})
export class LocationListComponent {
  @Input() locations: Location[] = [];
  @Output() locationSelected = new EventEmitter();

  switchLocation(location: LocationListItemComponent): void {
    location.goToLocation();
    this.onLocationSelected();
  }

  onLocationSelected(): void {
    this.locationSelected.emit();
  }
}
